import React, { useEffect, useState } from 'react';
import { GetFoodsOfSectionDay_FoodMeal_Api } from '../../API/FoodMealApi';
import { AFoodMealComponent } from './AFoodMealComponent';
import { Divider, Typography, Space } from 'antd'; // اضافه کردن Space و Typography

const { Title } = Typography;

export const ASectionFoodsComponent = ({
    setLoading,
    showMessage,
    reserve,
    day,
    foodSectionId,
    foodSectionTitle,
    reportMode = false,
    sectionColor, // Prop جدید
    sectionIcon,  // Prop جدید
}) => {
    const [foodMeals, setFoodMeals] = useState([]);
    const [version, setVersion] = useState(0);

    useEffect(() => {
        loadFoods();
    }, [version]);

    const loadFoods = async () => {
        setLoading(true);
        try {
            const data = await GetFoodsOfSectionDay_FoodMeal_Api({
                date_Shamsi: day.date_Shamsi,
                reserveId: reserve.id,
                foodSection: foodSectionId,
                day: day
            });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFoodMeals(data.messageData.data || []);
            } else {
                showMessage(data.message, "error");
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error");
        }
    };

    return (
        <>
            {foodMeals.length > 0 && (
                <div style={{
                    paddingTop: '15px', // افزایش padding
                    paddingBottom: '15px',
                    borderBottom: '1px solid #f0f0f0',
                }}>
                    <Space
                        align="center"
                        style={{
                            width: '100%',
                            justifyContent: 'center',
                            paddingBottom: '12px', // افزایش padding
                        }}
                    >
                        {sectionIcon} {/* نمایش آیکون */}
                        <Title level={5} style={{
                            margin: 0,
                            color: sectionColor, // استفاده از رنگ ارسالی
                            fontSize: '15px' // کمی بزرگتر
                        }}>
                            {foodSectionTitle}
                        </Title>
                    </Space>
                    {foodMeals.map((foodMeal) => (
                        <AFoodMealComponent
                            key={foodMeal.id}
                            foodMeal={foodMeal}
                            setLoading={setLoading}
                            showMessage={showMessage}
                            reserve={reserve}
                            date_Shamsi={day.date_Shamsi}
                            day={day} // <<<<<<<<<<< ارسال کل آبجکت day
                            foodSectionTitle={foodSectionTitle} // <<<<<<<<<<< ارسال foodSectionTitle
                            reportMode={reportMode}
                        />
                    ))}
                </div>
            )}
        </>
    );
};
